/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.1.4 bird2_low_re.glb -t -d
*/

import * as THREE from 'three'
import React, { createRef, useRef } from 'react'
import { meshBounds, useGLTF } from '@react-three/drei'
import { GLTF } from 'three-stdlib'
import { useFrame, useThree } from '@react-three/fiber'
import state from '../../../utils/state'

type GLTFResult = GLTF & {
  nodes: {
    Model: THREE.Mesh
  }
  materials: {
    ['material0.001']: THREE.MeshStandardMaterial
  }
}

export function Bird2(props: JSX.IntrinsicElements['group']) {
  const { nodes, materials } = useGLTF('./models/low_re/bird2_low_re.glb') as GLTFResult

  return (
    <group {...props} dispose={null}>
      <mesh geometry={nodes.Model.geometry} material={materials['material0.001']} material-metalness={0.95} material-roughness={0.62} position={[0, 0.01, 0]} rotation={[0.96, 0, 0]} raycast={meshBounds} />
    </group>
  )
}

// useGLTF.preload('/bird2_low_re.glb')
